export default [
    {
        name: 'Projetos',
        url: '/sgtec/gerentes/projetos',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'SGTEC-GER-PRJ-00'
    },
    {
        name: 'Etapas',
        url: '/sgtec/gerentes/etapas',
        icon: 'fa fa-tasks',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'SGTEC-GER-ETP-00'
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/gerentes/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'SGTEC-GER-PAG-00'
    },
    {
        name: 'Equipe de Apoio',
        url: '/sgtec/gerentes/apoios',
        icon: 'fa fa-users',
        regras: 'SGTEC-GER-APOIO-00'
    },
]
